var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8925 14.71C6.80734 14.8019 6.7061 14.8748 6.59458 14.9246C6.48306 14.9744 6.36347 15 6.2427 15C6.12192 15 6.00234 14.9744 5.89082 14.9246C5.7793 14.8748 5.67805 14.8019 5.59289 14.71L0.40365 9.1403C0.145193 8.86286 0 8.48662 0 8.09432C0 7.70202 0.145193 7.32578 0.40365 7.04834L1.05345 6.35102C1.31199 6.07366 1.66259 5.91785 2.02816 5.91785C2.39373 5.91785 2.74433 6.07366 3.00287 6.35102L6.2427 9.82776L14.9971 0.433167C15.2557 0.15581 15.6063 0 15.9718 0C16.3374 0 16.688 0.15581 16.9465 0.433167L17.5963 1.13049C17.8548 1.40793 18 1.78417 18 2.17647C18 2.56877 17.8548 2.94501 17.5963 3.22245L6.8925 14.71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.7791d2598db9c3988dbc87749418a67b.svg";
export { ForwardRef as ReactComponent };